module.exports = __webpack_public_path__ + "img/katarina_events_1.69c4b4fe.jpg";